import { useEffect, useRef, useState } from 'react';

import { blurDelay, keyEnter, keySpacebar } from '../constants/constants';
import { useBrowserScreen } from './useBrowserScreen';

export const useDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const { isMobileView } = useBrowserScreen();

  const handleShowMoreClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    setIsOpen((prevVal) => !prevVal);
  };

  const handleMenuItemClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    hasSubitems: boolean,
    handleMobileNavigationItemClick: () => void
  ) => {
    if (!isMobileView) {
      return;
    }

    if (hasSubitems) {
      e.preventDefault();
      setIsOpen((prevVal) => !prevVal);
    } else {
      handleMobileNavigationItemClick();
    }
  };

  const handleMouseOver = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === ' ' || e.key === keySpacebar || e.key === keyEnter) {
      e.preventDefault();
      setIsOpen((prevVal) => !prevVal);
    }
  };

  const handleDesktopBlur = () => {
    if (isMobileView) {
      return;
    }
    timer.current = setTimeout(() => {
      setIsOpen(false);
    }, blurDelay);
  };

  const handleDesktopOutsideBlur = (
    e: React.FocusEvent<HTMLElement, Element>
  ) => {
    if (e.currentTarget.contains(e.relatedTarget) && !isMobileView) {
      e.preventDefault();
      e.stopPropagation();

      return;
    }

    handleDesktopBlur();
  };

  const handleFocus = () => {
    if (timer.current) clearTimeout(timer.current);
  };

  const handleEsc = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      if (timer.current) clearTimeout(timer.current);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', handleEsc);

    return () => {
      window.removeEventListener('keyup', handleEsc);
    };
  }, []);

  return {
    handleDesktopBlur,
    handleDesktopOutsideBlur,
    handleFocus,
    handleShowMoreClick,
    handleMenuItemClick,
    handleKeyPress,
    handleMouseOver,
    isOpen,
  };
};
